import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import CompanyCustomerService from "services/Setup/Organization/companyCustomerService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",

  CompanyCustomerList: {},
  CompanyCustomerLegalDocList: {},
  CompanyCustomerShareHolderList: {},
  CompanyCustomerManagementList: {},
  CompanyCustomerFinanceList: {},
  responseStatusCpmnyIdnty: null,
  responseStatusLglDoc: null,
  responseStatusShreHldr: null,
  responseStatusMngmnt: null,
  responseStatusFinance: null,

  loadingIdentityCmpnyList: false,
  loadingLegalDocList: false,
  loadingShareHolderList: false,
  loadingManagementList: false,
  loadingFinanceList: false,

  IsIdentityCmpnyPosted: false,
  resultPostIdentityCmpny: {},

  IsLegalDocPosted: false,
  resultPostLegalDoc: {},

  IsShareHolderPosted: false,
  resultPostShareHolder: {},

  IsManagementPosted: false,
  resultPostManagement: {},

  IsFinancePosted: false,
  resultPostFinance: {},

  IsIdentityCmpnyUpdated: false,
  resultUpdateIdentityCmpny: {},

  IsLegalDocUpdated: false,
  resultUpdateLegalDoc: {},

  IsShareHolderUpdated: false,
  resultUpdateShareHolder: {},

  IsManagementUpdated: false,
  resultUpdateManagement: {},

  IsFinanceUpdated: false,
  resultUpdateFinance: {},

  CIFNO: "",
};

export const getCompanyCustomerList = createAsyncThunk(
  "companyCustomer/getCompanyCustomerList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await CompanyCustomerService.getCompanyCustomerList(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postCompanyCustomer = createAsyncThunk(
  "companyCustomer/postCompanyCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CompanyCustomerService.postCompanyCustomer(data);
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateCompanyCustomer = createAsyncThunk(
  "companyCustomer/updateCompanyCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CompanyCustomerService.updateCompanyCustomer(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteCompanyCustomer = createAsyncThunk(
  "companyCustomer/deleteCompanyCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CompanyCustomerService.deleteCompanyCustomer(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCompanyCustomerLegalDocList = createAsyncThunk(
  "companyCustomer/getCompanyCustomerLegalDocList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.getCompanyCustomerLegalDocList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postCompanyCustomerLegalDoc = createAsyncThunk(
  "companyCustomer/postCompanyCustomerLegalDoc",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CompanyCustomerService.postCompanyCustomerLegalDoc(
        data
      );
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postCompanyCustomerLegalDocCsv = createAsyncThunk(
  "companyCustomer/postCompanyCustomerLegalDocCsv",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.postCompanyCustomerLegalDocCsv(data);
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateCompanyCustomerLegalDoc = createAsyncThunk(
  "companyCustomer/updateCompanyCustomerLegalDoc",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.updateCompanyCustomerLegalDoc(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteCompanyCustomerLegalDoc = createAsyncThunk(
  "companyCustomer/deleteCompanyCustomerLegalDoc",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.deleteCompanyCustomerLegalDoc(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCompanyCustomerShareHolderList = createAsyncThunk(
  "companyCustomer/getCompanyCustomerShareHolderList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.getCompanyCustomerShareHolderList(
          userInput
        );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postCompanyCustomerShareHolder = createAsyncThunk(
  "companyCustomer/postCompanyCustomerShareHolder",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.postCompanyCustomerShareHolder(data);
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateCompanyCustomerShareHolder = createAsyncThunk(
  "companyCustomer/updateCompanyCustomerShareHolder",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.updateCompanyCustomerShareHolder(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteCompanyCustomerShareHolder = createAsyncThunk(
  "companyCustomer/deleteCompanyCustomerShareHolder",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.deleteCompanyCustomerShareHolder(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCompanyCustomerManagementList = createAsyncThunk(
  "companyCustomer/getCompanyCustomerManagementList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.getCompanyCustomerManagementList(
          userInput
        );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postCompanyCustomerManagement = createAsyncThunk(
  "companyCustomer/postCompanyCustomerManagement",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.postCompanyCustomerManagement(data);
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateCompanyCustomerManagement = createAsyncThunk(
  "companyCustomer/updateCompanyCustomerManagement",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.updateCompanyCustomerManagement(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteCompanyCustomerManagement = createAsyncThunk(
  "companyCustomer/deleteCompanyCustomerManagement",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.deleteCompanyCustomerManagement(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCompanyCustomerFinanceList = createAsyncThunk(
  "companyCustomer/getCompanyCustomerFinanceList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.getCompanyCustomerFinanceList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postCompanyCustomerFinance = createAsyncThunk(
  "companyCustomer/postCompanyCustomerFinance",
  async (data, { rejectWithValue }) => {
    try {
      const response = await CompanyCustomerService.postCompanyCustomerFinance(
        data
      );
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateCompanyCustomerFinance = createAsyncThunk(
  "companyCustomer/updateCompanyCustomerFinance",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.updateCompanyCustomerFinance(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteCompanyCustomerFinance = createAsyncThunk(
  "companyCustomer/deleteCompanyCustomerFinance",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await CompanyCustomerService.deleteCompanyCustomerFinance(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const CompanyCustomerSlice = createSlice({
  name: "companyCustomer",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetStateCompanyCustomer: () => initialState,
  },

  extraReducers: (builder) => {
    builder

      //list company Customer
      .addCase(getCompanyCustomerList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
        state.loadingIdentityCmpnyList = true;
      })
      .addCase(getCompanyCustomerList.fulfilled, (state, action) => {
        state.loading = false;
        state.CompanyCustomerList = action.payload;
        state.getCount = action.payload.count;
        state.loadingIdentityCmpnyList = false;
      })
      .addCase(getCompanyCustomerList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.loadingIdentityCmpnyList = true;
      })

      //post company Customer
      .addCase(postCompanyCustomer.pending, (state) => {
        state.loading = true;
        state.responseStatusCpmnyIdnty = 201;
        state.IsIdentityCmpnyPosted = false;
      })
      .addCase(postCompanyCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
        state.responseStatusCpmnyIdnty = action.payload.status;

        state.resultPostIdentityCmpny = action.payload.data.status;
        state.IsIdentityCmpnyPosted = true;
        state.CIFNO = action.payload.data.message;
      })
      .addCase(postCompanyCustomer.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.IsIdentityCmpnyPosted = false;
      })

      //update company Customer
      .addCase(updateCompanyCustomer.pending, (state) => {
        state.loading = true;
        state.responseStatusCpmnyIdnty = 201;
        state.IsIdentityCmpnyUpdated = false;
      })
      .addCase(updateCompanyCustomer.fulfilled, (state, action) => {
        console.log("🚀 ~ .updateCompanyCustomer ~ action:", action.payload);
        state.loading = false;
        state.responseStatusCpmnyIdnty = action.payload.status;
        state.IsIdentityCmpnyUpdated = true;
        state.resultUpdateIdentityCmpny = action.payload.data.status;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updateCompanyCustomer.rejected, (state, action) => {
        state.loading = false;
        state.IsIdentityCmpnyUpdated = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete company Customer
      .addCase(deleteCompanyCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCompanyCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteCompanyCustomer.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list company Customer (Legal Document)
      .addCase(getCompanyCustomerLegalDocList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
        state.loadingLegalDocList = true;
      })
      .addCase(getCompanyCustomerLegalDocList.fulfilled, (state, action) => {
        state.loading = false;
        state.CompanyCustomerLegalDocList = action.payload;
        state.getCount = action.payload.count;
        state.loadingLegalDocList = false;
      })
      .addCase(getCompanyCustomerLegalDocList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.loadingLegalDocList = true;
      })

      //post company Customer (Legal Document)
      .addCase(postCompanyCustomerLegalDoc.pending, (state) => {
        state.loading = true;
        state.responseStatusLglDoc = 201;
        state.IsLegalDocPosted = false;
      })
      .addCase(postCompanyCustomerLegalDoc.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
        state.responseStatusLglDoc = action.payload.status;
        state.resultPostLegalDoc = action.payload.data.status;
        state.IsLegalDocPosted = true;
      })
      .addCase(postCompanyCustomerLegalDoc.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.IsLegalDocPosted = false;
      })

      //post company Customer (Legal Document) csv
      .addCase(postCompanyCustomerLegalDocCsv.pending, (state) => {
        state.loading = true;
      })
      .addCase(postCompanyCustomerLegalDocCsv.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
      })
      .addCase(postCompanyCustomerLegalDocCsv.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //update company Customer (Legal Document)
      .addCase(updateCompanyCustomerLegalDoc.pending, (state) => {
        state.loading = true;
        state.responseStatusLglDoc = 201;
        state.IsLegalDocUpdated = false;
      })
      .addCase(updateCompanyCustomerLegalDoc.fulfilled, (state, action) => {
        state.loading = false;
        state.responseStatusLglDoc = action.payload.status;
        state.IsLegalDocUpdated = true;
        state.resultUpdateLegalDoc = action.payload.data.status;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updateCompanyCustomerLegalDoc.rejected, (state, action) => {
        state.loading = false;
        state.IsLegalDocUpdated = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete company Customer (Legal Document)
      .addCase(deleteCompanyCustomerLegalDoc.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCompanyCustomerLegalDoc.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteCompanyCustomerLegalDoc.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list company Customer (Share Holder)
      .addCase(getCompanyCustomerShareHolderList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
        state.loadingShareHolderList = true;
      })
      .addCase(getCompanyCustomerShareHolderList.fulfilled, (state, action) => {
        state.loading = false;
        state.CompanyCustomerShareHolderList = action.payload;
        state.getCount = action.payload.count;
        state.loadingShareHolderList = false;
      })
      .addCase(getCompanyCustomerShareHolderList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.loadingShareHolderList = true;
      })

      //post company Customer (Share Holder)
      .addCase(postCompanyCustomerShareHolder.pending, (state) => {
        state.loading = true;
        state.responseStatusShreHldr = 201;
        state.IsShareHolderPosted = false;
      })
      .addCase(postCompanyCustomerShareHolder.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
        state.responseStatusShreHldr = action.payload.status;
        state.resultPostShareHolder = action.payload.data.status;
        state.IsShareHolderPosted = true;
      })
      .addCase(postCompanyCustomerShareHolder.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.IsShareHolderPosted = false;
      })

      //update company Customer (Share Holder)
      .addCase(updateCompanyCustomerShareHolder.pending, (state) => {
        state.loading = true;
        state.responseStatusShreHldr = 201;
        state.IsShareHolderUpdated = false;
      })
      .addCase(updateCompanyCustomerShareHolder.fulfilled, (state, action) => {
        state.loading = false;
        state.responseStatusShreHldr = action.payload.status;
        state.IsShareHolderUpdated = true;
        state.resultUpdateShareHolder = action.payload.data.status;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updateCompanyCustomerShareHolder.rejected, (state, action) => {
        state.loading = false;
        state.IsShareHolderUpdated = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete company Customer (Share Holder)
      .addCase(deleteCompanyCustomerShareHolder.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCompanyCustomerShareHolder.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteCompanyCustomerShareHolder.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list company Customer (Management)
      .addCase(getCompanyCustomerManagementList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
        state.loadingManagementList = true;
      })
      .addCase(getCompanyCustomerManagementList.fulfilled, (state, action) => {
        state.loading = false;
        state.CompanyCustomerManagementList = action.payload;
        state.getCount = action.payload.count;
        state.loadingManagementList = false;
      })
      .addCase(getCompanyCustomerManagementList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.loadingManagementList = true;
      })

      //post company Customer (Management)
      .addCase(postCompanyCustomerManagement.pending, (state) => {
        state.loading = true;
        state.responseStatusMngmnt = 201;
        state.IsManagementPosted = false;
      })
      .addCase(postCompanyCustomerManagement.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
        state.responseStatusMngmnt = action.payload.status;
        state.resultPostManagement = action.payload.data.status;
        state.IsManagementPosted = true;
      })
      .addCase(postCompanyCustomerManagement.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.IsManagementPosted = false;
      })

      //update company Customer (Management)
      .addCase(updateCompanyCustomerManagement.pending, (state) => {
        state.loading = true;
        state.responseStatusMngmnt = 201;
        state.IsManagementUpdated = false;
      })
      .addCase(updateCompanyCustomerManagement.fulfilled, (state, action) => {
        state.loading = false;
        state.responseStatusMngmnt = action.payload.status;
        state.IsManagementUpdated = true;
        state.resultUpdateManagement = action.payload.data.status;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updateCompanyCustomerManagement.rejected, (state, action) => {
        state.loading = false;
        state.IsManagementUpdated = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete company Customer (Management)
      .addCase(deleteCompanyCustomerManagement.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCompanyCustomerManagement.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteCompanyCustomerManagement.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list company Customer (Finance)
      .addCase(getCompanyCustomerFinanceList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
        state.loadingFinanceList = true;
      })
      .addCase(getCompanyCustomerFinanceList.fulfilled, (state, action) => {
        state.loading = false;
        state.CompanyCustomerFinanceList = action.payload;
        state.getCount = action.payload.count;
        state.loadingFinanceList = false;
      })
      .addCase(getCompanyCustomerFinanceList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.loadingFinanceList = true;
      })

      //post company Customer (Finance)
      .addCase(postCompanyCustomerFinance.pending, (state) => {
        state.loading = true;
        state.responseStatusFinance = 201;
        state.IsFinancePosted = false;
      })
      .addCase(postCompanyCustomerFinance.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.redirect = "/";
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
        state.responseStatusFinance = action.payload.status;
        state.resultPostFinance = action.payload.data.status;
        state.IsFinancePosted = true;
      })
      .addCase(postCompanyCustomerFinance.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.IsFinancePosted = false;
      })

      //update company Customer (Finance)
      .addCase(updateCompanyCustomerFinance.pending, (state) => {
        state.loading = true;
        state.responseStatusFinance = 201;
        state.IsFinanceUpdated = false;
      })
      .addCase(updateCompanyCustomerFinance.fulfilled, (state, action) => {
        state.loading = false;
        state.responseStatusFinance = action.payload.status;
        state.IsFinanceUpdated = true;
        state.resultUpdateFinance = action.payload.data.status;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updateCompanyCustomerFinance.rejected, (state, action) => {
        state.loading = false;
        state.IsFinanceUpdated = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete company Customer (Finance)
      .addCase(deleteCompanyCustomerFinance.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCompanyCustomerFinance.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteCompanyCustomerFinance.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  resetStateCompanyCustomer,
  showNotification,
  hideNotification,
  showLoading,
} = CompanyCustomerSlice.actions;

export default CompanyCustomerSlice.reducer;
